import { IUserAuthDTO } from '../models/happy-code-api.model';
import { Predicate } from '../models/predicate.model';

export default function buildUserAccessPredicate(
  user: IUserAuthDTO,
  base = new Predicate(),
): Predicate {

  if(user.acessoB2c && user.acessoB2b) return base;

  if (user.acessoB2b) base.addOption('acessoB2b', true);
  if (user.acessoB2c) base.addOption('acessoB2c', true);


  return base;
}
